import React from 'react';
import './CompanyCard.css';

function CompanyCard({ name, description, image, website }) {
  return (
    <div className="company-card">
      <div className="company-logo-container">
        <img
          src={`/img/portfolio/${image}`}
          alt={`${name} logo`}
          className="company-logo"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
      <div className="company-content">
        <h3 className="company-name">{name}</h3>
        <p className="company-description">{description}</p>
        {website && (
          <a href={website} target="_blank" rel="noopener noreferrer" className="company-link">
            Visit Site >
          </a>
        )}
      </div>
    </div>
  );
}

export default CompanyCard; 